import React, { useState, useEffect } from "react";
import LineChart from "./LineChart";
import { useFirebase } from "../../database/FirebaseContext";

function BurnDownChart({ sprint, isOpenModel, colourBlindMode }) {
    const { getSprintData } = useFirebase();
    const [userData, setUserData] = useState({});
    const getBackgroundColorActual = (colourBlindMode) => {
        switch (colourBlindMode) {
            case true:
                return '#C96514';
            default:
                return '#FF3528';
        }
    };

    const getBackgroundColorExpected = (colourBlindMode) => {
        switch (colourBlindMode) {
            case true:
                return '#0033B1';
            default:
                return '#0000FF';
        }
    };

    useEffect(() => {
        const updateData = async () => {
            const rawSprintData = await getSprintData(sprint?.id);
            const newUserData = {
                labels: rawSprintData?.sprintDays,
                datasets: [
                    {
                        label: "Expected Burn Down",
                        data: rawSprintData?.expectedSPData,
                        borderColor: getBackgroundColorExpected(colourBlindMode),
                        backgroundColor: getBackgroundColorExpected(colourBlindMode)                        
                    },
                    {
                        label: "Actual Burn Down",
                        data: rawSprintData?.actualSPData,
                        borderColor: getBackgroundColorActual(colourBlindMode),
                        backgroundColor: getBackgroundColorActual(colourBlindMode)
                        
                    },
                ],
            };
            setUserData(newUserData);
        };

        updateData();
    }, [sprint]);

    const options = {
        plugins: {
            legend: {
                position: "top",
            },
            title: {
                display: true,
                text: "BurnDown Chart",
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: "Days", // Add your X axis title here
                },
            },
            y: {
                title: {
                    display: true,
                    text: "Story Points", // Add your Y axis title here
                },
            },
        },
    };

    return (
        <div className="flex w-9/12 h-[90%] bg-[#3D3E44] justify-center items-center ml-[17%] rounded-3xl">
            {isOpenModel === 2 && (
                <div className="w-full justify-center items-center">
                    <div className="flex w-full h-auto justify-center mt-[20px] mb-[30px]">
                        <p className="text-white text-[25px]">
                            {sprint.sprintName}
                        </p>
                    </div>
                    <div className="h-[100%] mx-[5%] bg-white">
                        <LineChart chartData={userData} labels={options} />
                    </div>
                    <div className="flex justify-center mt-[40px]"></div>
                </div>
            )}
        </div>
    );
}

export default BurnDownChart;
